import { Component } from 'vue-facing-decorator';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from './commands-core';

@Component
export default class VuePageCommands extends VueCqrs {
	invokeAcceptUserAccessRequestCommandV1(id: string)
	{
		const cmd = new c.AcceptUserAccessRequestCommandV1(id);
		this.$command(cmd);
	}

	invokeAssignBusinessUserRoleCommandV1(id: string)
	{
		const cmd = new c.AssignBusinessUserRoleCommandV1(id);
		this.$command(cmd);
	}

	invokeAssignGlobalAdminRoleCommandV1(id: string)
	{
		const cmd = new c.AssignGlobalAdminRoleCommandV1(id);
		this.$command(cmd);
	}

	invokeAssignOrganizationAdminRoleCommandV1(id: string)
	{
		const cmd = new c.AssignOrganizationAdminRoleCommandV1(id);
		this.$command(cmd);
	}

	invokeAssignWorkspaceUserRoleCommandV1(id: string)
	{
		const cmd = new c.AssignWorkspaceUserRoleCommandV1(id);
		this.$command(cmd);
	}

	invokeChangeOrganizationUnitCommandV1(id: string, organizationUnitId: number)
	{
		const cmd = new c.ChangeOrganizationUnitCommandV1(id, organizationUnitId);
		this.$command(cmd);
	}

	invokeChangePasswordCommandV1(id: string, password: string)
	{
		const cmd = new c.ChangePasswordCommandV1(id, password);
		this.$command(cmd);
	}

	invokeCreateServiceUserCommandV1(id: string, organizationUnitId: number | null, email: string, displayName: string)
	{
		const cmd = new c.CreateServiceUserCommandV1(id, organizationUnitId, email, displayName);
		this.$command(cmd);
	}

	invokeCreateUserCommandV1(id: string, organizationUnitId: number | null, email: string, firstName: string, lastName: string, isGlobalAdmin: boolean, isOrganizationAdmin: boolean, isWorkspaceUser: boolean, isBusinessUser: boolean, setInitialPassword: boolean, password: string | null)
	{
		const cmd = new c.CreateUserCommandV1(id, organizationUnitId, email, firstName, lastName, isGlobalAdmin, isOrganizationAdmin, isWorkspaceUser, isBusinessUser, setInitialPassword, password);
		this.$command(cmd);
	}

	invokeDisableUserCommandV1(id: string)
	{
		const cmd = new c.DisableUserCommandV1(id);
		this.$command(cmd);
	}

	invokeEnableUserCommandV1(id: string)
	{
		const cmd = new c.EnableUserCommandV1(id);
		this.$command(cmd);
	}

	invokeLockUserCommandV1(id: string, reason: string, unlockAt: any | null)
	{
		const cmd = new c.LockUserCommandV1(id, reason, unlockAt);
		this.$command(cmd);
	}

	invokeRejectUserAccessRequestCommandV1(id: string)
	{
		const cmd = new c.RejectUserAccessRequestCommandV1(id);
		this.$command(cmd);
	}

	invokeRequestResetPasswordCommandV1(email: string)
	{
		const cmd = new c.RequestResetPasswordCommandV1(email);
		this.$command(cmd);
	}

	invokeRequestSsoUrlCommandV1(id: string)
	{
		const cmd = new c.RequestSsoUrlCommandV1(id);
		this.$command(cmd);
	}

	invokeRequestUserAccessCommandV1(id: string, organizationUnitId: number, requestedBy: string, email: string, firstName: string, lastName: string, displayName: string)
	{
		const cmd = new c.RequestUserAccessCommandV1(id, organizationUnitId, requestedBy, email, firstName, lastName, displayName);
		this.$command(cmd);
	}

	invokeResetPasswordCommandV1(id: string, sendPasswordToEmail: string)
	{
		const cmd = new c.ResetPasswordCommandV1(id, sendPasswordToEmail);
		this.$command(cmd);
	}

	invokeRevokeBusinessUserRoleCommandV1(id: string)
	{
		const cmd = new c.RevokeBusinessUserRoleCommandV1(id);
		this.$command(cmd);
	}

	invokeRevokeGlobalAdminRoleCommandV1(id: string)
	{
		const cmd = new c.RevokeGlobalAdminRoleCommandV1(id);
		this.$command(cmd);
	}

	invokeRevokeOrganizationAdminRoleCommandV1(id: string)
	{
		const cmd = new c.RevokeOrganizationAdminRoleCommandV1(id);
		this.$command(cmd);
	}

	invokeRevokeServiceUserFlagCommandV1(id: string)
	{
		const cmd = new c.RevokeServiceUserFlagCommandV1(id);
		this.$command(cmd);
	}

	invokeRevokeWorkspaceUserRoleCommandV1(id: string)
	{
		const cmd = new c.RevokeWorkspaceUserRoleCommandV1(id);
		this.$command(cmd);
	}

	invokeSignInCommandV1(id: string, password: string, returnUrl: string)
	{
		const cmd = new c.SignInCommandV1(id, password, returnUrl);
		this.$command(cmd);
	}

	invokeSignoutFromAllSessionsCommandV1(id: string)
	{
		const cmd = new c.SignoutFromAllSessionsCommandV1(id);
		this.$command(cmd);
	}

	invokeSignoutFromSessionCommandV1(id: string, sessionId: string)
	{
		const cmd = new c.SignoutFromSessionCommandV1(id, sessionId);
		this.$command(cmd);
	}

	invokeUnlockUserCommandV1(id: string)
	{
		const cmd = new c.UnlockUserCommandV1(id);
		this.$command(cmd);
	}

	invokeUpdateUserDetailsCommandV1(id: string, firstName: string, lastName: string, displayName: string)
	{
		const cmd = new c.UpdateUserDetailsCommandV1(id, firstName, lastName, displayName);
		this.$command(cmd);
	}

	succeedAnyCommand(status: any) { }
	invalidAnyCommand(status: any) { }
	failedAnyCommand(status: any) { }

	onSetCommandStatus(status: any) {
		status.Success ? 
			this.succeedAnyCommand(status) :
			status.ValidationErrors ?
				this.invalidAnyCommand(status) :
				this.failedAnyCommand(status);

		if (c.AcceptUserAccessRequestCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedAcceptUserAccessRequestCommandV1(status) :
				status.ValidationErrors ?
					this.invalidAcceptUserAccessRequestCommandV1(status) :
					this.failedAcceptUserAccessRequestCommandV1(status);
			return;
		}

		if (c.AssignBusinessUserRoleCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedAssignBusinessUserRoleCommandV1(status) :
				status.ValidationErrors ?
					this.invalidAssignBusinessUserRoleCommandV1(status) :
					this.failedAssignBusinessUserRoleCommandV1(status);
			return;
		}

		if (c.AssignGlobalAdminRoleCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedAssignGlobalAdminRoleCommandV1(status) :
				status.ValidationErrors ?
					this.invalidAssignGlobalAdminRoleCommandV1(status) :
					this.failedAssignGlobalAdminRoleCommandV1(status);
			return;
		}

		if (c.AssignOrganizationAdminRoleCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedAssignOrganizationAdminRoleCommandV1(status) :
				status.ValidationErrors ?
					this.invalidAssignOrganizationAdminRoleCommandV1(status) :
					this.failedAssignOrganizationAdminRoleCommandV1(status);
			return;
		}

		if (c.AssignWorkspaceUserRoleCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedAssignWorkspaceUserRoleCommandV1(status) :
				status.ValidationErrors ?
					this.invalidAssignWorkspaceUserRoleCommandV1(status) :
					this.failedAssignWorkspaceUserRoleCommandV1(status);
			return;
		}

		if (c.ChangeOrganizationUnitCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedChangeOrganizationUnitCommandV1(status) :
				status.ValidationErrors ?
					this.invalidChangeOrganizationUnitCommandV1(status) :
					this.failedChangeOrganizationUnitCommandV1(status);
			return;
		}

		if (c.ChangePasswordCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedChangePasswordCommandV1(status) :
				status.ValidationErrors ?
					this.invalidChangePasswordCommandV1(status) :
					this.failedChangePasswordCommandV1(status);
			return;
		}

		if (c.CreateServiceUserCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedCreateServiceUserCommandV1(status) :
				status.ValidationErrors ?
					this.invalidCreateServiceUserCommandV1(status) :
					this.failedCreateServiceUserCommandV1(status);
			return;
		}

		if (c.CreateUserCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedCreateUserCommandV1(status) :
				status.ValidationErrors ?
					this.invalidCreateUserCommandV1(status) :
					this.failedCreateUserCommandV1(status);
			return;
		}

		if (c.DisableUserCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedDisableUserCommandV1(status) :
				status.ValidationErrors ?
					this.invalidDisableUserCommandV1(status) :
					this.failedDisableUserCommandV1(status);
			return;
		}

		if (c.EnableUserCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedEnableUserCommandV1(status) :
				status.ValidationErrors ?
					this.invalidEnableUserCommandV1(status) :
					this.failedEnableUserCommandV1(status);
			return;
		}

		if (c.LockUserCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedLockUserCommandV1(status) :
				status.ValidationErrors ?
					this.invalidLockUserCommandV1(status) :
					this.failedLockUserCommandV1(status);
			return;
		}

		if (c.RejectUserAccessRequestCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRejectUserAccessRequestCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRejectUserAccessRequestCommandV1(status) :
					this.failedRejectUserAccessRequestCommandV1(status);
			return;
		}

		if (c.RequestResetPasswordCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRequestResetPasswordCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRequestResetPasswordCommandV1(status) :
					this.failedRequestResetPasswordCommandV1(status);
			return;
		}

		if (c.RequestSsoUrlCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRequestSsoUrlCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRequestSsoUrlCommandV1(status) :
					this.failedRequestSsoUrlCommandV1(status);
			return;
		}

		if (c.RequestUserAccessCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRequestUserAccessCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRequestUserAccessCommandV1(status) :
					this.failedRequestUserAccessCommandV1(status);
			return;
		}

		if (c.ResetPasswordCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedResetPasswordCommandV1(status) :
				status.ValidationErrors ?
					this.invalidResetPasswordCommandV1(status) :
					this.failedResetPasswordCommandV1(status);
			return;
		}

		if (c.RevokeBusinessUserRoleCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRevokeBusinessUserRoleCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRevokeBusinessUserRoleCommandV1(status) :
					this.failedRevokeBusinessUserRoleCommandV1(status);
			return;
		}

		if (c.RevokeGlobalAdminRoleCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRevokeGlobalAdminRoleCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRevokeGlobalAdminRoleCommandV1(status) :
					this.failedRevokeGlobalAdminRoleCommandV1(status);
			return;
		}

		if (c.RevokeOrganizationAdminRoleCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRevokeOrganizationAdminRoleCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRevokeOrganizationAdminRoleCommandV1(status) :
					this.failedRevokeOrganizationAdminRoleCommandV1(status);
			return;
		}

		if (c.RevokeServiceUserFlagCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRevokeServiceUserFlagCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRevokeServiceUserFlagCommandV1(status) :
					this.failedRevokeServiceUserFlagCommandV1(status);
			return;
		}

		if (c.RevokeWorkspaceUserRoleCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedRevokeWorkspaceUserRoleCommandV1(status) :
				status.ValidationErrors ?
					this.invalidRevokeWorkspaceUserRoleCommandV1(status) :
					this.failedRevokeWorkspaceUserRoleCommandV1(status);
			return;
		}

		if (c.SignInCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedSignInCommandV1(status) :
				status.ValidationErrors ?
					this.invalidSignInCommandV1(status) :
					this.failedSignInCommandV1(status);
			return;
		}

		if (c.SignoutFromAllSessionsCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedSignoutFromAllSessionsCommandV1(status) :
				status.ValidationErrors ?
					this.invalidSignoutFromAllSessionsCommandV1(status) :
					this.failedSignoutFromAllSessionsCommandV1(status);
			return;
		}

		if (c.SignoutFromSessionCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedSignoutFromSessionCommandV1(status) :
				status.ValidationErrors ?
					this.invalidSignoutFromSessionCommandV1(status) :
					this.failedSignoutFromSessionCommandV1(status);
			return;
		}

		if (c.UnlockUserCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedUnlockUserCommandV1(status) :
				status.ValidationErrors ?
					this.invalidUnlockUserCommandV1(status) :
					this.failedUnlockUserCommandV1(status);
			return;
		}

		if (c.UpdateUserDetailsCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedUpdateUserDetailsCommandV1(status) :
				status.ValidationErrors ?
					this.invalidUpdateUserDetailsCommandV1(status) :
					this.failedUpdateUserDetailsCommandV1(status);
			return;
		}

	}

	succeedAcceptUserAccessRequestCommandV1(status: any) { }
	invalidAcceptUserAccessRequestCommandV1(status: any) { }
	failedAcceptUserAccessRequestCommandV1(status: any) { }

	succeedAssignBusinessUserRoleCommandV1(status: any) { }
	invalidAssignBusinessUserRoleCommandV1(status: any) { }
	failedAssignBusinessUserRoleCommandV1(status: any) { }

	succeedAssignGlobalAdminRoleCommandV1(status: any) { }
	invalidAssignGlobalAdminRoleCommandV1(status: any) { }
	failedAssignGlobalAdminRoleCommandV1(status: any) { }

	succeedAssignOrganizationAdminRoleCommandV1(status: any) { }
	invalidAssignOrganizationAdminRoleCommandV1(status: any) { }
	failedAssignOrganizationAdminRoleCommandV1(status: any) { }

	succeedAssignWorkspaceUserRoleCommandV1(status: any) { }
	invalidAssignWorkspaceUserRoleCommandV1(status: any) { }
	failedAssignWorkspaceUserRoleCommandV1(status: any) { }

	succeedChangeOrganizationUnitCommandV1(status: any) { }
	invalidChangeOrganizationUnitCommandV1(status: any) { }
	failedChangeOrganizationUnitCommandV1(status: any) { }

	succeedChangePasswordCommandV1(status: any) { }
	invalidChangePasswordCommandV1(status: any) { }
	failedChangePasswordCommandV1(status: any) { }

	succeedCreateServiceUserCommandV1(status: any) { }
	invalidCreateServiceUserCommandV1(status: any) { }
	failedCreateServiceUserCommandV1(status: any) { }

	succeedCreateUserCommandV1(status: any) { }
	invalidCreateUserCommandV1(status: any) { }
	failedCreateUserCommandV1(status: any) { }

	succeedDisableUserCommandV1(status: any) { }
	invalidDisableUserCommandV1(status: any) { }
	failedDisableUserCommandV1(status: any) { }

	succeedEnableUserCommandV1(status: any) { }
	invalidEnableUserCommandV1(status: any) { }
	failedEnableUserCommandV1(status: any) { }

	succeedLockUserCommandV1(status: any) { }
	invalidLockUserCommandV1(status: any) { }
	failedLockUserCommandV1(status: any) { }

	succeedRejectUserAccessRequestCommandV1(status: any) { }
	invalidRejectUserAccessRequestCommandV1(status: any) { }
	failedRejectUserAccessRequestCommandV1(status: any) { }

	succeedRequestResetPasswordCommandV1(status: any) { }
	invalidRequestResetPasswordCommandV1(status: any) { }
	failedRequestResetPasswordCommandV1(status: any) { }

	succeedRequestSsoUrlCommandV1(status: any) { }
	invalidRequestSsoUrlCommandV1(status: any) { }
	failedRequestSsoUrlCommandV1(status: any) { }

	succeedRequestUserAccessCommandV1(status: any) { }
	invalidRequestUserAccessCommandV1(status: any) { }
	failedRequestUserAccessCommandV1(status: any) { }

	succeedResetPasswordCommandV1(status: any) { }
	invalidResetPasswordCommandV1(status: any) { }
	failedResetPasswordCommandV1(status: any) { }

	succeedRevokeBusinessUserRoleCommandV1(status: any) { }
	invalidRevokeBusinessUserRoleCommandV1(status: any) { }
	failedRevokeBusinessUserRoleCommandV1(status: any) { }

	succeedRevokeGlobalAdminRoleCommandV1(status: any) { }
	invalidRevokeGlobalAdminRoleCommandV1(status: any) { }
	failedRevokeGlobalAdminRoleCommandV1(status: any) { }

	succeedRevokeOrganizationAdminRoleCommandV1(status: any) { }
	invalidRevokeOrganizationAdminRoleCommandV1(status: any) { }
	failedRevokeOrganizationAdminRoleCommandV1(status: any) { }

	succeedRevokeServiceUserFlagCommandV1(status: any) { }
	invalidRevokeServiceUserFlagCommandV1(status: any) { }
	failedRevokeServiceUserFlagCommandV1(status: any) { }

	succeedRevokeWorkspaceUserRoleCommandV1(status: any) { }
	invalidRevokeWorkspaceUserRoleCommandV1(status: any) { }
	failedRevokeWorkspaceUserRoleCommandV1(status: any) { }

	succeedSignInCommandV1(status: any) { }
	invalidSignInCommandV1(status: any) { }
	failedSignInCommandV1(status: any) { }

	succeedSignoutFromAllSessionsCommandV1(status: any) { }
	invalidSignoutFromAllSessionsCommandV1(status: any) { }
	failedSignoutFromAllSessionsCommandV1(status: any) { }

	succeedSignoutFromSessionCommandV1(status: any) { }
	invalidSignoutFromSessionCommandV1(status: any) { }
	failedSignoutFromSessionCommandV1(status: any) { }

	succeedUnlockUserCommandV1(status: any) { }
	invalidUnlockUserCommandV1(status: any) { }
	failedUnlockUserCommandV1(status: any) { }

	succeedUpdateUserDetailsCommandV1(status: any) { }
	invalidUpdateUserDetailsCommandV1(status: any) { }
	failedUpdateUserDetailsCommandV1(status: any) { }

}
